import React from "react";
import { Link } from "react-router-dom";
import "../styles/HeroSection.css";
import titleImg from "../images/title.png";

function HeroSection() {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1 className="hero-title">
          LINE導入から運用まで、<br></br>企業の成長を後押しする<br></br>
          マーケティングパートナー
        </h1>
        <Link to="/download" className="hero-button1">
          資料をダウンロードする
        </Link>
        <Link to="/inquiry" className="hero-button2">
          問い合わせをする
        </Link>
      </div>
      <img src={titleImg} alt="スマホ画像" className="hero-image-mobile" />
    </section>
  );
}

export default HeroSection;
